document.getElementById('AddToCart').addEventListener('click', function(event) {
  event.preventDefault(); // デフォルトのフォーム送信を防ぐ

  // 商品IDと数量を取得
  var variantId = document.querySelector('select[name="id"]').value;
  var quantity = document.querySelector('input[name="quantity"]').value;
  const popUp = document.querySelector('.buy-pop-up'); // 二重定義を解消
  
  // Ajaxリクエストでカートに追加
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('商品がカートに追加されました:', data);

    if (popUp) { // popUp要素が存在する場合のみ処理
      // 要素を表示する
      popUp.style.bottom = '150px';
      popUp.style.opacity = '1';

      // 3秒後に透明度を0にする
      setTimeout(function() {
        // アニメーション後にページをリロード
        setTimeout(function() {
          location.reload();
        });
      }, 600);
    } else {
      // popUpがない場合はすぐにリロード
      location.reload();
    }
  })
  .catch(error => {
    console.error('エラーが発生しました:', error);
  });
});